import { createStorefrontApiClient } from "@shopify/storefront-api-client";
import * as React from "react";

const client = createStorefrontApiClient({
  storeDomain: process.env.GATSBY_SHOPIFY_CUSTOM_DOMAIN,
  publicAccessToken: process.env.GATSBY_STOREFRONT_ACCESS_TOKEN,
  apiVersion: process.env.GATSBY_SHOPIFY_STOREFRONT_API_VERSION
})

const transformCart = (cart) => {
  return {
    ...cart,
    lines: cart.lines.edges.map(e => ({
      ...e.node,
    }))
  }
}

const artworksCartClient = {
  fetch: async (cartID) => {
    const result = await client.request(
      `query getCart($id: ID!) {
  node(id: $id) {
    ... on Cart {
      id
      checkoutUrl
      cost {
        subtotalAmount {
          currencyCode
          amount
        }
        totalAmount {
          currencyCode
          amount
        }
      }
      lines(first: 10) {
        edges {
          node {
            id
            merchandise {
              ... on ProductVariant {
                id
                title
                sku
                image {
                  id
                  altText
                  url
                  width
                  height
                  src
                }
                priceV2 {
                  currencyCode
                  amount
                }
                compareAtPriceV2 {
                  currencyCode
                  amount
                }
                product {
                  id
                  title
                }
              }
            }
            quantity
          }
        }
      }
    }
  }
}`, {
      variables: { id: cartID },
    });
    // console.log('hereee result fetch', result)

    return {
      ...transformCart(result.data.node)
    };
  },
  create: async () => {
    const result = await client.request(
      `mutation cartCreate($cartInput: CartInput) {
        cartCreate(input: $cartInput) {
        cart {
          id
        }
        userErrors {
          field
          message
        }
      }
    }`,
      {
        variables: {
          cartInput: {

          },
        }
      });
    // console.log('hereee result cartCreate', result)
    if (result.data.cartCreate.userErrors.length > 0) {
      throw new Error(result.data.cartCreate.userErrors[0].message);
    }
    return result.data.cartCreate.cart;
  },
  addLines: async (cartID, linesToUpdate) => {
    const result = await client.request(
      `mutation cartLinesAdd($cartId: ID!, $lines: [CartLineInput!]!) {
  cartLinesAdd(cartId: $cartId, lines: $lines) {
    cart {
      id
      checkoutUrl
      cost {
        subtotalAmount {
          currencyCode
          amount
        }
        totalAmount {
          currencyCode
          amount
        }
      }
      lines(first: 10) {
        edges {
          node {
            id
            merchandise {
              ... on ProductVariant {
                id
                title
                sku
                image {
                  id
                  altText
                  url
                  width
                  height
                  src
                }
                priceV2 {
                  currencyCode
                  amount
                }
                compareAtPriceV2 {
                  currencyCode
                  amount
                }
                product {
                  id
                  title
                }
              }
            }
            quantity
          }
        }
      }
    }
    userErrors {
      field
      message
    }
  }
}`,
      {
        variables: { cartId: cartID, lines: linesToUpdate },
      });
    // console.log('hereee result cartLinesAdd', result)
    if (result.data.cartLinesAdd.userErrors.length > 0) {
      throw new Error(result.data.cartLinesAdd.userErrors[0].message);
    }

    return {
      ...transformCart(result.data.cartLinesAdd.cart)
    }
  },
  removeLines: async (cartID, lineItemIDs) => {
    const result = await client.request(
      `mutation cartLinesRemove($cartId: ID!, $lineIds: [ID!]!) {
  cartLinesRemove(cartId: $cartId, lineIds: $lineIds) {
    cart {
      id
      checkoutUrl
      cost {
        subtotalAmount {
          currencyCode
          amount
        }
        totalAmount {
          currencyCode
          amount
        }
      }
      lines(first: 10) {
        edges {
          node {
            id
            merchandise {
              ... on ProductVariant {
                id
                title
                sku
                image {
                  id
                  altText
                  url
                  width
                  height
                  src
                }
                priceV2 {
                  currencyCode
                  amount
                }
                compareAtPriceV2 {
                  currencyCode
                  amount
                }
                product {
                  id
                  title
                }
              }
            }
            quantity
          }
        }
      }
    }
    userErrors {
      field
      message
    }
  }
}`,
      {
        variables: { cartId: cartID, lineIds: lineItemIDs },
      });
    // console.log('hereee result cartLinesRemove', result)
    if (result.data.cartLinesRemove.userErrors.length > 0) {
      throw new Error(result.data.cartLinesRemove.userErrors[0].message);
    }

    return {
      ...transformCart(result.data.cartLinesRemove.cart)
    }
  },
  updateLines: async (cartID, linesToUpdate) => {
    const result = await client.request(
      `mutation cartLinesUpdate($cartId: ID!, $lines: [CartLineUpdateInput!]!) {
  cartLinesUpdate(cartId: $cartId, lines: $lines) {
    cart {
      id
      checkoutUrl
      cost {
        subtotalAmount {
          currencyCode
          amount
        }
        totalAmount {
          currencyCode
          amount
        }
      }
      lines(first: 10) {
        edges {
          node {
            id
            merchandise {
              ... on ProductVariant {
                id
                title
                sku
                image {
                  id
                  altText
                  url
                  width
                  height
                  src
                }
                priceV2 {
                  currencyCode
                  amount
                }
                compareAtPriceV2 {
                  currencyCode
                  amount
                }
                product {
                  id
                  title
                }
              }
            }
            quantity
          }
        }
      }
    }
    userErrors {
      field
      message
    }
  }
}`,
      {
        variables: { cartId: cartID, lines: linesToUpdate },
      });
    // console.log('hereee result updateLines', cartID, linesToUpdate, result)
    if (result.data.cartLinesUpdate.userErrors.length > 0) {
      throw new Error(result.data.cartLinesUpdate.userErrors[0].message);
    }
    return {
      ...transformCart(result.data.cartLinesUpdate.cart)
    }
  },
}

const defaultValues = {
  isOpen: false,
  loading: false,
  onOpen: () => { },
  onClose: () => { },
  addVariantToCart: () => { },
  removeLineItem: () => { },
  updateLineItem: () => { },
  client: artworksCartClient,
  cart: {
    lines: [],
  },
}

export const StoreContext = React.createContext(defaultValues)

const isBrowser = typeof window !== `undefined`
const localStorageKey = `shopify_cart_id`
const ensureCartDefaults = (cart) => {
  if (!cart) return defaultValues['cart']

  if (!cart.lines) cart.lines = defaultValues['cart']['lines']

  return cart;
}

export const StoreProvider = ({ children }) => {
  const [cart, setCart] = React.useState(defaultValues.cart)
  const [loading, setLoading] = React.useState(false)
  const [didJustAddToCart, setDidJustAddToCart] = React.useState(false)

  const setCartState = (cart) => {
    setCart(ensureCartDefaults(cart))
  }

  const setCartItem = (cart) => {
    if (isBrowser) {
      localStorage.setItem(localStorageKey, cart.id)
    }

    setCartState(cart)
  }

  React.useEffect(() => {
    const initializeCart = async () => {
      const existingCartID = isBrowser
        ? localStorage.getItem(localStorageKey)
        : null

      if (existingCartID && existingCartID !== `null`) {
        try {
          const existingCart = await artworksCartClient.fetch(
            existingCartID
          )
          if (!existingCart.completedAt) {
            setCartItem(existingCart)
            return
          }
        } catch (e) {
          localStorage.setItem(localStorageKey, null)
        }
      }

      const newCart = await artworksCartClient.create()
      setCartItem(newCart)
    }

    initializeCart()
  }, [])

  const addVariantToCart = (variantId, quantity) => {
    setLoading(true);

    const cartID = cart.id;

    const linesToUpdate = [
      {
        merchandiseId: variantId,
        quantity: parseInt(quantity, 10),
      },
    ]

    return artworksCartClient
      .addLines(cartID, linesToUpdate)
      .then((res) => {
        setCartState(res);
        setLoading(false);
        setDidJustAddToCart(true);
        setTimeout(() => setDidJustAddToCart(false), 3000);
      })
      .catch((error) => {
        //console.error("Error adding variant to cart:", error);
        setLoading(false);
      });
  }

  const removeLineItem = (cartID, lineItemID) => {
    setLoading(true)

    return artworksCartClient
      .removeLines(cartID, [lineItemID])
      .then((res) => {
        setCartState(res)
        setLoading(false)
      })
  }

  const updateLineItem = (cartID, lineItemID, quantity) => {
    setLoading(true)

    const linesToUpdate = [
      { id: lineItemID, quantity: parseInt(quantity, 10) },
    ]

    return artworksCartClient
      .updateLines(cartID, linesToUpdate)
      .then((res) => {
        setCartState(res)
        setLoading(false)
      })
  }

  // console.log(cart); 

  return (
    <StoreContext.Provider
      value={{
        ...defaultValues,
        addVariantToCart,
        removeLineItem,
        updateLineItem,
        cart,
        loading,
        didJustAddToCart,
      }}
    >
      {children}
    </StoreContext.Provider>
  )
}
